<template>
  <div>
    <div class="flex items-center justify-between">
      <p class="title">{{ title }}</p>
      <div class="ml-auto">
        <search-nav-item-keyword size="large" placeholder="사용자 ID 검색" v-model="searchUserId" />
      </div>
    </div>
    <vs-table v-if="type === 'info'" @selected="handleSelected" @sort="handleSort" @search="handleSearch" pagination :max-items="getUsers && getUsers.length > 0 ? 5 : 1" :data="getUsers" class="ct-table mt-5">
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th v-for="col in colData" :key="`head-${col.head}`">{{ col.head }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ !!data[indextr].id ? data[indextr].id : "-" }}</vs-td>
          <vs-td v-for="col in colData" :key="`body-${col.head}`">{{ !!data[indextr][col.key] ? data[indextr][col.key] : "-" }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-table v-else @selected="handleSelected" @sort="handleSort" @search="handleSearch" pagination :max-items="getUsers && getUsers.length > 0 ? 5 : 1" :data="getUsers" class="ct-table mt-5">
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th v-for="col in colData" :key="`head-${col.head}`">{{ col.head }}</vs-th>
        <vs-th>{{ permissionHead }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <colgroup>
          <col width="100" />
        </colgroup>
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ indextr + 1 }}</vs-td>
          <vs-td v-for="col in colData" :key="`body-${col.head}`">{{ data[indextr][col.key] }}</vs-td>
          <vs-td class="flex justify-center">
            <vs-select v-model="tr.join_project" autocomplete @change="onChangeJoinProject">
              <vs-select-item text="미참여" :value="false" />
              <vs-select-item text="참여" :value="true" />
            </vs-select>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
export default {
  name: "CompanyUserAuthModule",
  components: { SearchNavItemKeyword },
  props: {
    value: Array,
    type: {
      type: String,
      default: () => {
        return "";
      },
    },
    users: Array,
    title: {
      type: String,
      default: () => {
        return "참여 인원 정보";
      },
    },
    isEmail: {
      type: Boolean,
      default: true,
    },
    colData: {
      type: Array,
      default: () => {
        return [
          { head: "구분", key: "company_id" },
          { head: "사용자명", key: "name" },
          { head: "사용자 ID", key: "username" },
          { head: "연락처", key: "phone" },
          { head: "이메일", key: "email" },
        ];
      },
    },
    permissionHead: {
      type: String,
      default: () => {
        return "권한설정";
      },
    },
  },
  data() {
    return {
      joinProjects: [],
      page: {
        current: 1,
        perPage: 100,
      },
      searchUserId: "",
    };
  },
  computed: {
    getUsers() {
      const list = [];
      if (this.users) {
        for (const user of this.users) {
          if (this.searchUserId) {
            if (user.username.indexOf(this.searchUserId) >= 0) {
              list.push(user);
            }
          } else {
            list.push(user);
          }
        }
      }
      return list;
    },
  },
  watch: {
    value(data) {
      this.joinProjects = data;
    },
  },
  mounted() {
    this.joinProjects = this.value;
  },
  methods: {
    handleSelected() {},
    handleSort() {},
    handleSearch() {},
    onChangeJoinProject() {
      const list = [];
      for (const user of this.users) {
        if (user.join_project) {
          list.push(user);
        }
      }
      this.$emit("input", list);
    },
  },
};
</script>

<style scoped lang="scss">
.ct-table::v-deep {
  .vs-table {
    table-layout: fixed;
    text-align: center;
    .vs-table-text {
      justify-content: center;
    }
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
